import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {CustomMessageService, ResponseHttpError, ResponseHttpSuccess, UtilService} from "library";
import {HttpStatusCode} from "@angular/common/http";
import {RequestService} from "../../../../../services/api/v1/request.service";

@Component({
  selector: 'app-sales-phone-enrollment-manual-app-instalation',
  templateUrl: './sales-phone-enrollment-manual-app-instalation.component.html',
  styles: [
  ]
})
export class SalesPhoneEnrollmentManualAppInstalationComponent implements OnInit{
  requestId: string;
  person!:any;
  contractNumber!: string;
  request: any;
  @Output() nextStepEvent = new EventEmitter();

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private utilService: UtilService,
              private customMessageService: CustomMessageService,) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.request = this.requestService.request;
  }

  ngOnInit() {
    this.load();
  }

  load(){
    this.utilService.enablePageLoading();
    this.person = {...this.request.person};
    this.contractNumber = this.request.number;
    this.utilService.disablePageLoading();
  }

  downLoadApp(){
    window.open('https://play.google.com/store/search?q=krediya&c=apps&hl=es_419', '_blank');
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

}
